import script from "./ProfessionalGraduationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalGraduationForm.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalGraduationForm.vue?vue&type=style&index=0&id=abb7055e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abb7055e"]])

export default __exports__